module.exports = __webpack_public_path__ + "img/Frame4295.718d67a3.jpg";